import React from 'react';

// due to the (un)wrapping of the text at different viewport sizes, we need extra media queries outside the usual breakpoints

function BrowseByBudgetPlaceholder({ children, topMarginOnly, fullWidth = false }) {
    return (
        <div
            className={`search-by-budget-placeholder ${topMarginOnly ? 'margin-top-4 margin-top-md-5' : 'margin-vertical-4 margin-vertical-md-5'}`} // margin is different in HP vs. LandingPage
            // to match MarketingValueContainer
            style={fullWidth ? { margin: '0 auto' } : { maxWidth: '1280px', margin: '0 auto' }}
        >
            {children}
        </div>
    );
}

export default BrowseByBudgetPlaceholder;
